import type { Fragment } from "../types.js";
import { defaultPad, getSafeZone, type PlatformId } from "../format.js";
import type { FormatId } from "../format.js";
import { indent } from "../composition.js";

/**
 * SafeArea — absolute container with format-appropriate padding (and optional
 * platform safe-zone). Mirrors `src/primitives/FormatLayout.tsx::SafeArea`.
 *
 * Children should be a single multi-line HTML string.
 */
export function safeArea(opts: {
  id: string;
  format: FormatId;
  childrenHtml: string;
  pad?: number;
  platform?: PlatformId;
}): Fragment {
  const { id, format, pad, platform, childrenHtml } = opts;

  let positioning: string;
  if (platform) {
    const sz = getSafeZone(format, platform);
    positioning = `top:${sz.top}px;bottom:${sz.bottom}px;left:${sz.left}px;right:${sz.right}px;padding:${sz.inner}px;`;
  } else {
    const p = pad ?? defaultPad(format);
    positioning = `top:0;right:0;bottom:0;left:0;padding:${p}px;`;
  }

  const html = `<div id="${id}" class="safe-area" style="position:absolute;${positioning}display:flex;flex-direction:column;justify-content:center;align-items:stretch;">
${indent(childrenHtml, 2)}
</div>`;

  return { html };
}
